// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"97d3b325","275":"5c6ac6f9","891":"f37846df"}[chunkId] + ".chunk.css";
};